import { Gender } from '../enums/gender-enums';

export const GenderData = [
  { label: Gender.MALE, value: Gender.MALE },
  { label: Gender.FEMALE, value: Gender.FEMALE },
];
